import Check from '@mui/icons-material/Check'
import {
  Box,
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Typography
} from '@mui/material'
import { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { LSCurrentUserShopId } from '../../config'
import useAccessTokenAndShopId from '../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { AppRoutes } from '../../models/AppRoutes'
import { AuthContext } from '../../providers'
import { MyRole } from '../../sdk'

export const SwitchShopDialog = ({
  handleCloseDialog
}: {
  handleCloseDialog: () => void
}) => {
  const navigate = useNavigate()
  const { shopId } = useAccessTokenAndShopId()
  const [isSwitching, setIsSwitching] = useState(false)

  const { setUserShopId, currentUser } = useContext(AuthContext)

  const switchShop = (selectedShop: string) => {
    setIsSwitching(true)
    localStorage.setItem(LSCurrentUserShopId, selectedShop)
    setUserShopId(selectedShop)
    navigate(AppRoutes.WORK_IN_PROGRESS)
    handleCloseDialog()
    setIsSwitching(false)
  }
  return (
    <>
      <DialogContent>
        <Typography variant="subtitle1">Switch to a different shop</Typography>
        {isSwitching && (
          <Box sx={{ display: 'flex' }}>
            <CircularProgress />
          </Box>
        )}
        {currentUser?.roles && currentUser.roles.length > 0 && (
          <MenuList>
            {currentUser.roles.map((r: MyRole) => (
              <MenuItem key={r.shop} onClick={() => switchShop(r.shop!)}>
                {shopId === r.shop && (
                  <ListItemIcon>
                    <Check />
                  </ListItemIcon>
                )}
                <ListItemText
                  inset={shopId !== r.shop}
                  primary={`${r.roleName} at ${r.shopName}`}
                />
              </MenuItem>
            ))}
          </MenuList>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDialog}>Cancel</Button>
      </DialogActions>
    </>
  )
}
